/* ============================================================
   GOGETTERS shared shell gedrag
   Bron: inline <script> van ~/GOGETTERS/gogetters-homepage.html
   Draait op elke pagina. Alles is null-safe zodat het ook werkt
   op Shopify-eigen templates (cart, product, zoeken).
   Pagina-specifiek gedrag staat in de secties zelf en gebruikt
   de helpers window.ggT / window.ggSetI18nText / window.ggReducedMotion.
   ============================================================ */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.ggReducedMotion = reducedMotion;

  /* ---- Licht/donker: voorkeur onthouden ---- */
  (function () {
    var saved = null;
    try { saved = localStorage.getItem('gg-theme'); } catch (e) {}
    document.documentElement.dataset.theme = saved || 'light';
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('#themeToggle, .theme-toggle');
      if (!btn) return;
      var next = document.documentElement.dataset.theme === 'light' ? 'dark' : 'light';
      document.documentElement.dataset.theme = next;
      try { localStorage.setItem('gg-theme', next); } catch (err) {}
    });
  })();

  /* ---- Scroll-reactieve achtergrond (--sy) ---- */
  (function () {
    if (reducedMotion) return;
    var ticking = false;
    function upd() {
      document.documentElement.style.setProperty('--sy', (window.scrollY / window.innerHeight).toFixed(3));
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(upd); ticking = true; }
    }, { passive: true });
    upd();
  })();

  /* ---- i18n helpers voor tekst die JS zelf schrijft ---- */
  var t = function (s) { return window.GGi18n ? window.GGi18n.t(s) : s; };
  var setI18nText = function (el, key, arg) {
    if (!el) return;
    el.dataset.i18nKey = key;
    if (arg == null) delete el.dataset.i18nArg; else el.dataset.i18nArg = arg;
    el.textContent = t(key).replace('%s', arg == null ? '' : arg);
  };
  window.ggT = t;
  window.ggSetI18nText = setI18nText;
  document.addEventListener('gg:langchange', function () {
    document.querySelectorAll('[data-i18n-key]').forEach(function (el) {
      var arg = el.dataset.i18nArg;
      el.textContent = t(el.dataset.i18nKey).replace('%s', arg == null ? '' : arg);
    });
  });

  /* ---- Generieke count-up, gedeeld door meerdere pagina's ---- */
  var formatNum = function (val, decimals) {
    /* Getalnotatie volgt de actieve taal (gg-i18n zet <html lang>): NL/DE "12.000" en "4,9", EN "12,000". */
    var loc = document.documentElement.lang || 'en';
    try {
      return decimals > 0
        ? val.toLocaleString(loc, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
        : Math.round(val).toLocaleString(loc);
    } catch (e) {
      return decimals > 0 ? val.toFixed(decimals) : String(Math.round(val));
    }
  };
  function animateCount(el) {
    var target = parseFloat(el.dataset.count);
    var decimals = parseInt(el.dataset.decimals || '0', 10);
    var suffix = el.dataset.suffix || '';
    if (reducedMotion) { el.textContent = formatNum(target, decimals) + suffix; return; }
    var duration = 1600;
    var start = performance.now();
    var tick = function (now) {
      var p = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = formatNum(target * eased, decimals) + (p === 1 ? suffix : '');
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }
  window.ggAnimateCount = animateCount;

  /* ---- Scroll-reveal: klassen toekennen en observeren ---- */
  var REVEAL_GROUPS = '.pain-grid,.vs-grid,.why-grid,.aud-grid,.pricing-grid,.steps,.stats-row,' +
    '.faq-col,.cap-list,.flow-mock,.footer-grid,.gps-grid';
  var REVEAL_SINGLES = '.section-head,.value-card,.transition-line,.risk-line,.rv-hero,.rv-foot,' +
    '.platform-note,.honest-card,.free-banner,.billing-wrap';

  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  var countObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animateCount(entry.target);
        countObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });

  /* Idempotent: kan opnieuw lopen na een sectie-herlaad in de thema-editor. */
  function wire(root) {
    root = root || document;

    root.querySelectorAll(REVEAL_GROUPS).forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (el, i) {
        el.classList.add('reveal');
        el.style.setProperty('--d', Math.min(i * 90, 450) + 'ms');
      });
    });
    root.querySelectorAll(REVEAL_SINGLES).forEach(function (el) { el.classList.add('reveal'); });
    root.querySelectorAll('.value-table tbody tr').forEach(function (el, i) {
      el.classList.add('reveal');
      el.style.setProperty('--d', (i * 80) + 'ms');
    });
    root.querySelectorAll('.reveal').forEach(function (el) {
      if (el.dataset.ggRevealed) return;
      el.dataset.ggRevealed = '1';
      revealObserver.observe(el);
    });
    root.querySelectorAll('.count').forEach(function (el) {
      if (el.dataset.ggCounted) return;
      el.dataset.ggCounted = '1';
      countObserver.observe(el);
    });

    /* FAQ accordeon */
    root.querySelectorAll('.faq-q').forEach(function (btn) {
      if (btn.dataset.ggFaq) return;
      btn.dataset.ggFaq = '1';
      btn.setAttribute('type', 'button');
      if (!btn.hasAttribute('aria-expanded')) btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var item = btn.parentElement;
        var answer = item.querySelector('.faq-a');
        if (!answer) return;
        var open = !item.classList.contains('open');
        answer.style.maxHeight = open ? answer.scrollHeight + 'px' : '0';
        item.classList.toggle('open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* Tabbladen in de dashboard-mockup (features-pagina) */
    var dashTabs = root.querySelectorAll('#dashTabs span');
    if (dashTabs.length) {
      var panes = root.querySelectorAll('.mockpane');
      dashTabs.forEach(function (tab, i) {
        if (tab.dataset.ggTab) return;
        tab.dataset.ggTab = '1';
        var activate = function () {
          dashTabs.forEach(function (t, j) { t.classList.toggle('on', i === j); });
          panes.forEach(function (p, j) { p.classList.toggle('on', i === j); });
        };
        tab.addEventListener('click', activate);
        tab.addEventListener('mouseenter', activate);
      });
    }

    /* Stap-tijdlijn tekent zich in */
    var stepsEl = root.querySelector('.steps');
    if (stepsEl && !stepsEl.dataset.ggLine) {
      stepsEl.dataset.ggLine = '1';
      var lineObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('line-in');
            lineObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });
      lineObserver.observe(stepsEl);
    }
  }
  window.ggWire = wire;

  /* ---- Sticky nav + mobiele drawer ---- */
  function wireChrome() {
    var nav = document.getElementById('nav');
    if (nav && !nav.dataset.ggWired) {
      nav.dataset.ggWired = '1';
      var onScroll = function () { nav.classList.toggle('scrolled', window.scrollY > 24); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    var hamburger = document.getElementById('hamburger');
    var drawer = document.getElementById('drawer');
    var backdrop = document.getElementById('drawerBackdrop');
    if (hamburger && drawer && backdrop && !drawer.dataset.ggWired) {
      drawer.dataset.ggWired = '1';
      var toggleDrawer = function (open) {
        hamburger.classList.toggle('open', open);
        drawer.classList.toggle('open', open);
        backdrop.classList.toggle('open', open);
        document.body.style.overflow = open ? 'hidden' : '';
      };
      hamburger.addEventListener('click', function () {
        toggleDrawer(!drawer.classList.contains('open'));
      });
      backdrop.addEventListener('click', function () { toggleDrawer(false); });
      drawer.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { toggleDrawer(false); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') toggleDrawer(false);
      });
    }
  }

  /* ---- Hero-parallax (fx-lagen, sparkles, mockup) ---- */
  function wireParallax() {
    if (reducedMotion) return;
    /* .fx-bg krijgt bewust GEEN transform meer. De vlekken erin gebruiken
       mix-blend-mode (in het lichte thema multiply); een transform maakt een
       nieuwe stacking context waardoor ze anders gaan mengen en de rand van de
       laag als naad zichtbaar werd zodra je ging scrollen. */
    var sparks = document.querySelector('.hero-sparks');
    var mockup = document.querySelector('.mockup');
    if (!sparks && !mockup) return;
    if (document.documentElement.dataset.ggParallax) return;
    document.documentElement.dataset.ggParallax = '1';
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY || 0;
        if (sparks) sparks.style.transform = 'translate3d(0,' + (y * 0.14) + 'px,0)';
        if (mockup) {
          var r = mockup.getBoundingClientRect();
          var vh = window.innerHeight || 800;
          var p = Math.max(0, Math.min(1, (vh - r.top) / (vh * 0.9)));
          mockup.style.transform = 'rotateX(' + ((1 - p) * 13).toFixed(2) + 'deg)';
        }
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Vertaalbundel op aanvraag ----
     gg-i18n.js is 91 KB. Een Engelse bezoeker heeft hem niet nodig, dus laden we
     hem alleen bij een andere taalkeuze, of vooruit zodra iemand de
     taalwisselaar nadert. Het bestand initialiseert zichzelf na het laden. */
  var i18nBezig = false;
  function ggLoadI18n() {
    if (i18nBezig || !window.ggI18nSrc || window.GGi18n) return;
    i18nBezig = true;
    var sc = document.createElement('script');
    sc.src = window.ggI18nSrc;
    sc.defer = true;
    document.head.appendChild(sc);
  }
  window.ggLoadI18n = ggLoadI18n;

  /* Taalkeuze (gg-header): open/dicht. De opties zijn gewone links naar het domein van
     die taal; vertalingen komen uit Translate & Adapt, niet meer uit gg-i18n.js. */
  function wireI18n() {
    var sws = document.querySelectorAll('.lang-switch');
    if (!sws.length) return;
    /* Pagina-adressen verschillen per taal (/pages/prijzen vs /pages/pricing).
       Shopify zet de juiste adressen in de hreflang-links in de <head>; neem die over. */
    var alts = document.querySelectorAll('link[rel="alternate"][hreflang]');
    document.querySelectorAll('a.lang-opt[hreflang]').forEach(function (a) {
      var host = a.hostname, lang = a.getAttribute('hreflang');
      for (var i = 0; i < alts.length; i++) {
        var hl = alts[i].getAttribute('hreflang');
        if ((hl === lang || hl.indexOf(lang + '-') === 0) && alts[i].href.indexOf('//' + host + '/') > -1) {
          a.href = alts[i].href; break;
        }
      }
    });
    var closeAll = function () {
      sws.forEach(function (sw) {
        sw.setAttribute('data-open', 'false');
        var tg = sw.querySelector('.lang-toggle'); if (tg) tg.setAttribute('aria-expanded', 'false');
      });
    };
    sws.forEach(function (sw) {
      if (sw.dataset.ggWired) return; sw.dataset.ggWired = '1';
      var tg = sw.querySelector('.lang-toggle');
      if (!tg) return;
      tg.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = sw.getAttribute('data-open') === 'true';
        closeAll();
        sw.setAttribute('data-open', open ? 'false' : 'true');
        tg.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
    if (!window.__ggLangDoc) {
      window.__ggLangDoc = true;
      document.addEventListener('click', closeAll);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    }
  }

  function boot() { wireChrome(); wire(document); wireParallax(); wireI18n(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Thema-editor laadt secties opnieuw; opnieuw aankoppelen. */
  document.addEventListener('shopify:section:load', function (e) {
    wireChrome();
    wire(e.target);
    wireParallax();
    /* De nieuwe sectie staat in het Engels; opnieuw vertalen. */
    if (window.GGi18n) window.GGi18n.refresh();
  });
})();
